import type { KeyValueType } from "@/core/api/graphql/types";

/**
 * Collects 10 of the 11 browser-based fields recommended by CyberSource for Payer Authentication.
 * These fields serve as a backup in case the Device Data Collection does not complete correctly.
 *
 * Note: deviceInformation.ipAddress is excluded because it cannot be determined client-side.
 * The backend should extract the IP address from the request.
 *
 * @see https://developer.cybersource.com/docs/cybs/en-us/payer-authentication/developer/all/rest/payer-auth/pa2-ccdc-ddc-intro.html
 */
export function collectBrowserData(): KeyValueType[] {
  return [
    {
      key: "consumerAuthenticationInformation.deviceChannel",
      value: "Browser",
    },
    {
      key: "deviceInformation.httpAcceptContent",
      value: "text/html,application/xhtml+xml,application/xml;q=0.9,*/*;q=0.8",
    },
    {
      key: "deviceInformation.httpBrowserColorDepth",
      value: String(window.screen.colorDepth),
    },
    {
      key: "deviceInformation.httpBrowserJavaEnabled",
      value: String(navigator.javaEnabled()),
    },
    {
      key: "deviceInformation.httpBrowserJavaScriptEnabled",
      value: "true",
    },
    {
      key: "deviceInformation.httpBrowserLanguage",
      value: navigator.language,
    },
    {
      key: "deviceInformation.httpBrowserScreenHeight",
      value: String(window.screen.height),
    },
    {
      key: "deviceInformation.httpBrowserScreenWidth",
      value: String(window.screen.width),
    },
    {
      key: "deviceInformation.httpBrowserTimeDifference",
      value: String(new Date().getTimezoneOffset()),
    },
    {
      key: "deviceInformation.userAgentBrowserValue",
      value: navigator.userAgent,
    },
  ];
}
